import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

interface CreateKeyDialogProps {
  open: boolean;
  keyType: "live" | "test";
  onClose: () => void;
  onSubmit: (name: string, type: "live" | "test") => void;
  loading: boolean;
}

export default function CreateKeyDialog({
  open,
  keyType,
  onClose,
  onSubmit,
  loading,
}: CreateKeyDialogProps) {
  const [name, setName] = useState("");

  const label = keyType === "live" ? "Production" : "Test";
  const prefix = keyType === "live" ? "pk_live_" : "pk_test_";

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(name || "Default", keyType);
    setName("");
  };

  const handleClose = () => {
    setName("");
    onClose();
  };

  const titleId = "create-key-dialog-title";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby={titleId}
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id={titleId}>Create {label} Key</DialogTitle>
        <DialogContent>
          <TextField
            label="Key Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            placeholder="e.g. My App, Staging, CI Pipeline"
            helperText={`A ${label.toLowerCase()} key (${prefix}*) will be generated.`}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? "Creating..." : `Create ${label} Key`}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
